'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Searches a string and separates the string by the text it finds
 * matchText: array of parts
 * @param  {String} text   text in which to search
 * @param  {String} queryText   text to search
 * @param  {String} mode search strategy, contains or startsWidth
 * @return {Array} matches e.g. ['hey', {match: 'test'}, 'rest of text']
 */
function hightlightText(_ref) {
  var queryText = _ref.queryText,
      text = _ref.text,
      _ref$mode = _ref.mode,
      mode = _ref$mode === undefined ? 'contains' : _ref$mode;

  var regex = mode === 'contains' ? new RegExp(queryText, 'gi') : new RegExp('^' + queryText, 'gi');

  var matchText = [];
  var searchQueryLen = queryText.length;
  var localMatch = void 0;
  var previousLocalMatch = void 0;

  // while you find a word
  while ((localMatch = regex.exec(text)) !== null) {
    var index = localMatch.index;
    var previousSegmentIndex = previousLocalMatch ? previousLocalMatch.index + searchQueryLen : 0;

    // text before match
    matchText.push(text.slice(previousSegmentIndex, index));
    matchText.push({
      match: text.slice(localMatch.index, localMatch.index + searchQueryLen)
    });

    previousLocalMatch = localMatch;
  }

  // at the end we apend the rest of the string
  matchText.push(text.slice(previousLocalMatch.index + searchQueryLen));
  matchText = matchText.filter(function (match) {
    return match;
  });

  return matchText;
}

exports.default = hightlightText;